// Safely convert Firestore Timestamp or string to JS Date
export function toJsDate(dt: any): Date {
  if (dt && typeof dt === "object" && typeof dt.toDate === "function") {
    return dt.toDate();
  }
  return new Date(dt);
}
